/* eslint-disable react/prop-types */
/**
 * /settings/operations — manager/admin/owner only.
 *
 * Fleet vehicles (Asset manager) + Phone normaliser (admin only).
 */
import { useAuth } from "../../context/AuthContext";
import { EntityShell } from "../../components/shell";
import { AssetManagerBlock, PhoneNormaliserBlock } from "./_blocks";

export default function OperationsSettings() {
  const { user } = useAuth();
  const isManager = user?.role === "owner" || user?.role === "admin" || user?.role === "manager";

  if (!isManager) {
    return (
      <EntityShell kindLabel="Settings" title="Operations" backTo="/settings">
        <div className="hv-card p-5 text-sm text-[#a0aabf]" data-testid="operations-settings-forbidden">
          Manager access required.
        </div>
      </EntityShell>
    );
  }

  return (
    <EntityShell kindLabel="Settings" title="Operations" backTo="/settings">
      <div className="space-y-4" data-testid="settings-operations-page">
        <AssetManagerBlock />
        {user?.role === "admin" && <PhoneNormaliserBlock />}
      </div>
    </EntityShell>
  );
}
